import { doc, getDoc } from 'firebase/firestore';

import { db } from '~/config/firebase.config';
import { postToStripeServer } from '~/services/subscription/subscriptionActions';
import { isReferralCode, normalizeReferralCode } from '~/utils/referral';

export type ReferralRewards = { count: number; amountCents: number; currency: string | null };
export type ReferralCode = { code: string; venueName: string | null; rewards?: ReferralRewards | null };

/** Code de parrainage du lieu (créé à la 1re demande par stripe-b2b). null si indisponible. */
export async function getMyReferralCode(clientId: string): Promise<ReferralCode | null> {
    try {
        const res = await postToStripeServer<ReferralCode>('/referral/code', { clientId });
        return res && isReferralCode(res.code) ? res : null;
    } catch {
        return null;
    }
}

/**
 * Lieu derrière un code (`referralCodes/{CODE}`, lisible publiquement) : `{ venueName }` si le code
 * existe, `null` s'il n'existe pas, `undefined` si la lecture a échoué (réseau : on n'affirme rien).
 */
export async function lookupReferralCode(raw: string): Promise<{ venueName: string | null } | null | undefined> {
    const code = normalizeReferralCode(raw);
    if (!isReferralCode(code)) return null;
    try {
        const snap = await getDoc(doc(db, 'referralCodes', code));
        if (!snap.exists()) return null;
        const venueName = snap.data()?.venueName;
        return { venueName: typeof venueName === 'string' && venueName.trim() ? venueName.trim() : null };
    } catch {
        return undefined;
    }
}
